<template>
  <div style="text-align: center;">
    <audio controls ref="audio" class="aud"  controlsList="nodownload noplaybackrate">
      <source :src="audio" />
    </audio>
  </div>
</template>

<script>

export default {
  name: "AdminPcIndex",
  data() {
    return {
      audio:''
    };
  },

  mounted() { },

  methods: {
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/audioDialog/index.vue